import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

import { BlockContent } from '~/components'

import { Task, TaskStatus } from '../types/Categorization.type'

interface Props {
  task: Task
}

function TaskCard({ task }: Props): React.ReactElement {
  const { setNodeRef, attributes, listeners, transform, transition, isDragging } = useSortable({
    id: task.id,
    data: {
      type: 'Task',
      task,
    },
    disabled: task.check,
  })

  const style = {
    transition,
    transform: CSS.Transform.toString(transform),
  }

  if (isDragging) {
    return (
      <div
        className="opacity-30 bg-mainBackgroundColor p-2.5 h-20 items-center flex text-left rounded border-2 border-rose-500 cursor-grab relative"
        ref={setNodeRef}
        style={style}
      />
    )
  }
  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners} className={getBackgroundStyle()}>
      <p className="text-white text-center w-full text-xs md:text-md leading-tight">
        <BlockContent blocks={task.content} />
      </p>
    </div>
  )

  function getBackgroundStyle(): string {
    const def = 'flex rounded border-4 min-h-17 md:min-h-20 w-full items-center text-center touch-action-none '

    if (task.check) {
      task.taskStatus = task.category === task.columnId ? TaskStatus.Right : TaskStatus.Wrong
      return task.taskStatus === TaskStatus.Right
        ? `bg-green-checkmark border-green-moderate-dark ${def} `
        : `bg-red-error border-red-dark ${def} `
    } else {
      return `bg-gradient-purple-dark-top border-purple ${def} `
    }
  }
}

export default TaskCard
